var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHome = function SvgHome(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "inherit",
    fillRule: "evenodd",
    d: "M10.133 3.068a.19.19 0 0 0-.266 0L4.5 8.436v8.126c0 .104.084.188.188.188h2.687v-3.313c0-.932.756-1.687 1.688-1.687h1.874c.933 0 1.688.755 1.688 1.687v3.313h2.688a.19.19 0 0 0 .187-.188V8.436zM17 9.936l.595.594a.75.75 0 1 0 1.06-1.06l-7.462-7.463a1.687 1.687 0 0 0-2.386 0L3.22 7.594 1.345 9.47a.75.75 0 0 0 1.06 1.06L3 9.936v6.626c0 .932.756 1.688 1.688 1.688h10.625c.931 0 1.687-.756 1.687-1.688zm-5.875 6.814h-2.25v-3.313c0-.103.084-.187.188-.187h1.874c.104 0 .188.084.188.187z",
    clipRule: "evenodd"
  })));
};
export default SvgHome;